
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M256 256v170.663H0V256h256z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M512 85.337V256H256V85.337h256z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M128 123.034l11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M384 293.697l11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"}})])
          )
        }
      }
    